<template>

  <!--  字段查看-->
  <div class="parser" :style="align?'justify-content: space-around;':''">
    <div v-if="showlabel && print"
         style="width: 170px;color: #000;font-weight: 600;text-align: left;padding:10px 10px;font-size: 18px;border:solid 1px #000000">
      {{ temp.name }}
    </div>

    <!--    查看状态下 label样式-->
    <div v-else-if="showlabel&& !print"
         style="width: 160px; margin-left: 20px; text-align: right;height: 20px;font-family: PingFang SC, PingFang SC;font-weight: bold;font-size: 16px;color: #000000;line-height: 16px;font-style: normal;text-transform: none;margin-right: 45px;">
      {{ temp.name }}
    </div>
    <span v-if="datas[temp.key]"
          :style="showlabel&& print?'padding:10px;color:#000;font-size: 18px;border:solid 1px #000;width:calc(100% - 210px);text-align: left':showlabel&&!print?'font-family: PingFang SC, PingFang SC;font-weight: bold;font-size: 16px;color: #000000;line-height: 16px;text-align: left;font-style: normal;text-transform: none;':''">
                     <!--          地址-->
              <div v-if="temp.type=='address'">
                 {{ datas[temp.key].address }}
              </div>
              <div v-else-if="temp.type=='activityselect'">
                <span v-if="datas[temp.key]&&datas[temp.key].label">
                 {{ datas[temp.key].label }}
                </span>
              </div>
                     <!--          时间-->
              <div v-else-if="temp.type=='time'">
                  <span v-if="temp.is_range">
                    {{ u.formatDateTime(3, datas[temp.key][0]) }} - {{ u.formatDateTime(3, datas[temp.key][1]) }}
                  </span>
                  <span v-else>
                    {{ u.formatDateTime(3, datas[temp.key]) }}
                  </span>
              </div>
                     <!--          时间-->
              <div v-else-if="temp.type=='date'">
                  <span v-if="temp.is_range">
                    {{ u.formatDateTime(2, datas[temp.key][0]) }} - {{ u.formatDateTime(2, datas[temp.key][1]) }}
                  </span>
                  <span v-else>
                    {{ u.formatDateTime(2, datas[temp.key]) }}
                  </span>
              </div>
                     <!--          时间日期-->
              <div v-else-if="temp.type=='datetime'">
                  <span v-if="temp.is_range">
                    {{ u.formatDateTime(1, datas[temp.key][0]) }} - {{ u.formatDateTime(1, datas[temp.key][1]) }}
                  </span>
                  <span v-else>
                    {{ u.formatDateTime(1, datas[temp.key]) }}
                  </span>
              </div>

              <div v-else-if="temp.type=='user'">
                  <span v-for="(item2,index2) in datas[temp.key]">
                    {{ item2.name }}
                  </span>
              </div>
            <div v-else-if="temp.type=='department'">
                <span v-for="(item2,index2) in datas[temp.key]">
                  {{ item2.name }}
                </span>
            </div>

            <div v-else-if="temp.type=='select'">
                {{ datas[temp.key].label }}
            </div>

            <div v-else-if="temp.type=='dataselect'">
                {{ datas[temp.key].name }}
            </div>


            <div v-else-if="temp.type=='checkbox'">
                <span v-for="(item2,index2) in datas[temp.key]">
                  {{ item2 }}
                </span>
            </div>

          <div v-else-if="temp.type=='file'">
              <span v-for="(item2,index2) in datas[temp.key]">
                <span class="btn-txt" @click="dowloadfile(u.config().static+'/'+item2)"><u>{{ item2 }}</u></span>&nbsp;
              </span>
          </div>
          <div v-else-if="temp.type=='image'" style="display: flex;align-items: center;justify-content: space-around">
                 <el-image
                   v-if="datas[temp.key].length>0"
                   style="width: 40px; height: 30px"
                   :src="u.config().static+'/'+ datas[temp.key][0]"
                   :preview-src-list="geturlist(datas[temp.key])">
              </el-image>
            <span v-if="datas[temp.key].length>0">
                共{{ datas[temp.key].length }}张
            </span>
          </div>
          <div v-else>
          <span v-if="temp.prefix" style="margin-right: 10px ;color: #666;font-size: 12px"> {{ temp.prefix }}</span>{{ datas[temp.key] }}  <span
            style="margin-left: 10px ;color: #666;font-size: 12px">{{ temp.suffix }}</span>
          </div>
      </span>
  </div>
</template>
<script>
import u from "../../../assets/js/util";

export default {
  name: "parser_view",
  props: ["temp", "datas", "option", "showlabel", "align", "print"],
  data() {
    return {
      u
    }
  },
  mounted() {
  },
  methods: {

    geturlist(list) {

      var imglist = []

      for (var i = 0; i < list.length; i ++) {
        imglist.push(u.config().static + '/' + list[i])

      }
      return imglist

    },
    dowloadfile(url) {
      window.open(url)
    },
  }
}
</script>

<style scoped>
.parser {
  display: flex;
  width: 100%;
  text-align: center;

}
</style>



// WEBPACK FOOTER //
// src/page/module/util/parser_view.vue